export default "__VITE_ASSET__DQcUWB7l__"